import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ModalTypes } from '../Constants';
import {} from '../actions';
import Utils from '../sources/Utils';
import Styles from './MazeSet/MazeStatic.cssmodule.less';

class MazeStatic extends Component {
    constructor(props) {
        super(props);

        this.configData = {
            '1': CpartyJRData,
            '2': StudyData,
            '3': StudyData,
            '5': StudyMazeData,
        };

        this.prefixSystem = [
            Ntry.GridSystem,
            Ntry.MazeSystem,
            Ntry.Animator,
            Ntry.CanvasRenderer,
            Ntry.Restorer,
            Ntry.SoundSystem,
            Ntry.UnitSystem,
            Ntry.Interpreter,
            Ntry.MazeStaticIntro,
            Ntry.MazeStaticResult,
        ];

        this.modeSystem = {
            '1': [
                Ntry.JrItemSystem,
                Ntry.JrEngineView,
                Ntry.jrPlayground,
                Ntry.JrHint,
            ],
            '2': [
                Ntry.ItemSystem,
                Ntry.MazeEngineView,
                Ntry.entryPlayground,
                Ntry.StudyCodingpartyHint,
            ],
            '3': [
                Ntry.JrItemSystem,
                Ntry.JrEngineView,
                Ntry.entryPlayground,
                Ntry.StudyCodingpartyHint,
            ],
            '5': [
                Ntry.ItemSystem,
                Ntry.MazeEngineView,
                Ntry.entryPlayground,
                Ntry.StudyCodingpartyHint,
            ],
        };
    }

    /* Lifecycle Events */
    componentWillMount() {}

    componentDidMount() {
        this.setMazeView(this.props);
    }

    shouldComponentUpdate({ data = {} }) {
        const { data: orgData = {} } = this.props;
        const { isReset } = data;
        return isReset || data._id !== orgData._id;
    }

    componentWillUpdate(nextProps) {
        this.setMazeView(nextProps);
    }

    componentWillUnmount() {
        this.mazeStaticPopup = undefined;
    }
    /* Lifecycle Events */

    setMazeView(props) {
        Entry.Utils.bindGlobalEvent();

        const {
            contents = {},
            isHomework,
            isHomeworkLapse,
            isLastStudy,
            code,
            isReset,
        } = props.data;
        const { mode, stage, goal, content = [] } = contents;
        const [introData] = content;

        Ntry.clearNtry();

        window.scrollTo(0, 0);
        if (!Entry.mediaFilePath) {
            Entry.mediaFilePath = '/lib/entry-js/images/';
        }

        Entry.commander = new Entry.Commander();
        Entry.Utils.initEntryEvent_();
        Entry.Utils.makeActivityReporter();

        const components = [
            Ntry.Position,
            Ntry.Grid,
            Ntry.Sprite,
            Ntry.Restore,
            Ntry.Bitmap,
            Ntry.Tile,
            Ntry.Unit,
            Ntry.Item,
            Ntry.Animate,
            Ntry.Code,
        ];
        const systems = this.prefixSystem.concat(this.modeSystem[mode]);
        const device =
            window.platform && window.platform.type ? 'tablet' : null;
        Ntry.initialize({
            components: components,
            systems: systems,
            device: device,
        });

        const configData = this.configData[mode];
        let stageId = stage;

        if (mode == 3) {
            stageId = Number(stageId) + 12;
        }

        const config = configData.config[stageId];
        config.stageId = stageId;
        config.modeId = mode;
        config.isHomework = isHomework;
        config.isHomeworkLapse = isHomeworkLapse;
        config.isLastStudy = isLastStudy;
        config.introData = introData;

        if (goal) {
            const { intro = {}, hints = {} } = config;
            if (mode == 1) {
                hints[0].content = goal;
            } else {
                intro.content = goal;
            }
        }

        const player = configData.player[stageId];
        let originCode;
        if (!_.isEmpty(code) && !isReset) {
            if (player.code) originCode = player.code;
            player.code = code;
        }

        Ntry.loadConfig(config);
        this.setMazeEntities(configData, mode, stageId);

        if (originCode) player.code = originCode;

        if (Entry.getMainWS()) {
            const entryMode = {
                boardType: Entry.Workspace.MODE_BOARD,
                textType: -1,
                runType: 0,
            };
            Entry.getMainWS().setMode(entryMode);
        }
    }

    setMazeEntities(configData, stageMode, stageId) {
        var entities = [];

        if (configData.tileMap && configData.tileMap[stageId]) {
            entities = entities.concat(
                Ntry.createTileEntities(configData.tileMap[stageId])
            );
        }

        if (configData.obstacle && configData.obstacle[stageId]) {
            entities = entities.concat(
                Ntry.createObstacleEntities(configData.obstacle[stageId])
            );
        }

        if (configData.item && configData.item[stageId]) {
            entities = entities.concat(
                Ntry.createJRItemEntities(configData.item[stageId])
            );
        }

        if (configData.fence_behind && configData.fence_behind[stageId]) {
            entities = entities.concat(
                Ntry.createFenceEntities(configData.fence_behind[stageId])
            );
        }

        if (configData.goal && configData.goal[stageId]) {
            entities = entities.concat(
                Ntry.createGoalEntities(configData.goal[stageId])
            );
        }

        if (stageMode == 1) {
            entities = entities.concat(
                Ntry.createJRItemEntities(configData.item[stageId])
            );
            entities = entities.concat([
                Ntry.createCpartyJuniEntity(configData.player[stageId]),
            ]);
        } else if (stageMode == 2) {
            entities = entities.concat([
                Ntry.createMazeJuniEntity(configData.player[stageId]),
            ]);
        } else if (stageMode == 3) {
            entities = entities.concat([
                Ntry.createCarPlayerEntity(configData.player[stageId]),
            ]);
        } else if (stageMode == 4) {
            entities = entities.concat(Ntry.createSpaceEntity(stageId - 2));
            entities = entities.concat(
                Ntry.createSpace(configData.space_map[stageId], stageId - 2)
            );
            entities = entities.concat(
                Ntry.createCodeSpaceShip(configData.player[stageId])
            );
        } else if (stageMode == 5 || stageMode == 6) {
            entities = entities.concat([
                Ntry.createMazeJuniEntity(StudyMazeData.player[stageId]),
            ]);
        }

        Ntry.entityManager.fromJSON(entities);
        Ntry.systemManager.update();

        entities = [];
        if (configData.fence_front && configData.fence_front[stageId]) {
            entities = entities.concat(
                Ntry.createFenceEntities(configData.fence_front[stageId])
            );

            Ntry.entityManager.fromJSON(entities);
            Ntry.systemManager.update();
        }
    }

    render() {
        const { contents = {} } = this.props.data;
        const { mode, stage } = contents;

        if (!mode || !stage) {
            return null;
        }

        return (
            <div className={`${Styles.mazeStaticStageWrapper}`}>
                <div id="ntry" className={`${Styles.mazeStatic}`} />
            </div>
        );
    }
}

MazeStatic.displayName = 'MazeStatic';
MazeStatic.propTypes = {};
MazeStatic.defaultProps = {
    data: {
        title: '',
    },
};

export default MazeStatic;



// WEBPACK FOOTER //
// ./components/MazeStatic.js